// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.avatar[data-v-1e1e8394] {\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n}\n", ""]);
// Exports
module.exports = exports;
